import { IHeader } from "ag-grid-community";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { isSalesInActive } from "../../common/salescredit/salescredit-helper";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import { AgFormat } from "../../common/utils/agGridFormat";

interface ITeamsalesbymonth {
  [key: string]: {
    team: string;
    teamLongName: string;
    sales: string;
    assignmentClosingDate: string;
    ytd: number;
    jan: number;
    feb: number;
    mar: number;
    apr: number;
    may: number;
    jun: number;
    jul: number;
    aug: number;
    sep: number;
    oct: number;
    nov: number;
    dec: number;
    ytd1: number;
    ytd2: number;
    ytd3: number;
  };
}
export function getMapping(data: IGenericAggregateResponse, profile: string) {
  if (!data.aggregates || data.aggregates.length === 0) {
    return [];
  }
  let teamsalesbymonth: ITeamsalesbymonth = {};
  teamsalesbymonth = ProcessRow(data, profile);
  return getValues(teamsalesbymonth);
}

function ProcessRow(
  data: IGenericAggregateResponse,
  profile: string
): ITeamsalesbymonth {
  const pd = new SCProfileDictionary();
  const teamsalesbymonth: ITeamsalesbymonth = {};
  const asofdate = data.request ? data.request.date : "";
  if (data.aggregates === undefined) {
    return teamsalesbymonth;
  }
  for (const row of data.aggregates) {
    const team = row.dimensionAttributeValues[SCAttributes.SC_SALESBEN_TEAM];
    const teamLongName =
      row.dimensionAttributeValues[SCAttributes.SC_SALESBEN_TEAM_LNAME];
    const assignmentClosingDate =
      row.dimensionAttributeValues[SCAttributes.SC_SALESBEN_ASSIGNCLOSINGDATE];
    const sales = isSalesInActive(asofdate, assignmentClosingDate)
      ? "INACTIVE SALES"
      : row.dimensionAttributeValues[SCAttributes.SC_SALESBEN_SALES];
    const monthId =
      row.dimensionAttributeValues[SCAttributes.SC_PERIOD_MONTH_ID];
    const monthFigure =
      row.indicatorKpiValues[pd.GetKpi(profile, SCKpis.SC_YTD)];
    const key = team + sales;
    let ytd = row.indicatorKpiValues[pd.GetKpi(profile, SCKpis.SC_YTD)];
    ytd = isNaN(ytd) ? 0 : ytd;
    let ytd1 = row.indicatorKpiValues[pd.GetKpi(profile, SCKpis.SC_YTD_1)];
    ytd1 = isNaN(ytd1) ? 0 : ytd1;
    let ytd2 = row.indicatorKpiValues[pd.GetKpi(profile, SCKpis.SC_YTD_2)];
    ytd2 = isNaN(ytd2) ? 0 : ytd2;
    let ytd3 = row.indicatorKpiValues[pd.GetKpi(profile, SCKpis.SC_YTD_3)];
    ytd3 = isNaN(ytd3) ? 0 : ytd3;

    AddRow(team, teamLongName, sales, teamsalesbymonth);
    teamsalesbymonth[key].ytd += ytd;
    teamsalesbymonth[key].ytd1 += ytd1;
    teamsalesbymonth[key].ytd2 += ytd2;
    teamsalesbymonth[key].ytd3 += ytd3;

    const monthLookup = [
      "jan",
      "feb",
      "mar",
      "apr",
      "may",
      "jun",
      "jul",
      "aug",
      "sep",
      "oct",
      "nov",
      "dec",
    ];
    (teamsalesbymonth[key] as any)[
      monthLookup[Number(monthId) - 1]
    ] = monthFigure;
  }
  return teamsalesbymonth;
}

function getValues(teamsalesbymonth: ITeamsalesbymonth) {
  const values: any[] = [];
  for (const key of Object.keys(teamsalesbymonth)) {
    values.push({
      Sales: teamsalesbymonth[key].sales,
      Team: teamsalesbymonth[key].team,
      TeamLongName: teamsalesbymonth[key].teamLongName,
      Ytd: teamsalesbymonth[key].ytd,
      Ytd1: teamsalesbymonth[key].ytd1,
      Ytd2: teamsalesbymonth[key].ytd2,
      Ytd3: teamsalesbymonth[key].ytd3,
      // tslint:disable-next-line:object-literal-sort-keys
      Jan: teamsalesbymonth[key].jan,
      Feb: teamsalesbymonth[key].feb,
      Mar: teamsalesbymonth[key].mar,
      Apr: teamsalesbymonth[key].apr,
      May: teamsalesbymonth[key].may,
      Jun: teamsalesbymonth[key].jun,
      Jul: teamsalesbymonth[key].jul,
      Aug: teamsalesbymonth[key].aug,
      Sep: teamsalesbymonth[key].sep,
      Oct: teamsalesbymonth[key].oct,
      Nov: teamsalesbymonth[key].nov,
      Dec: teamsalesbymonth[key].dec,
    });
  }
  return values;
}

function AddRow(
  team: string,
  teamLongName: string,
  sales: string,
  currentData: {
    [key: string]: {
      team: string;
      teamLongName: string;
      sales: string;
      ytd: number;
      jan: number;
      feb: number;
      mar: number;
      apr: number;
      may: number;
      jun: number;
      jul: number;
      aug: number;
      sep: number;
      oct: number;
      nov: number;
      dec: number;
      ytd1: number;
      ytd2: number;
      ytd3: number;
    };
  }
) {
  const key = team + sales;

  if (!(key in currentData)) {
    // tslint:disable:object-literal-sort-keys
    currentData[key] = {
      team,
      teamLongName,
      sales,
      ytd: 0,
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      oct: 0,
      nov: 0,
      dec: 0,
      ytd1: 0,
      ytd2: 0,
      ytd3: 0,
    };
  }
}

export function getHeaderDefinition(): IHeader[] {
  const textRight = "text-right";
  const header = [
    {
      cellRenderer: "group",
      cellStyle: AgFormat.AgRowGroupHeaderStyle,
      enableTooltip: true,
      headerName: "Team",
      showRowGroup: "Team",
      tooltipField: "TeamLongName",
      width: 330,
    },
    {
      cellRenderer: "group",
      field: "Team",
      hide: true,
      rowGroupIndex: 0,
      showRowGroup: "Team",
    },
    {
      cellStyle: AgFormat.AgRowGroupHeaderStyle,
      field: "Sales",
      headerName: "Sales Person",
      width: 450,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      comparator: AgFormat.AgNumberComparator,
      enableValue: true,
      field: "Ytd",
      headerName: "YTD (K€)",
      sort: "desc",
      valueGetter: AgFormat.AgGridFormatMoney,
      width: 300,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      comparator: AgFormat.AgNumberComparator,
      enableValue: true,
      field: "Jan",
      headerName: "Jan",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: "text-right",
      cellStyle: AgFormat.AgNumaricStyle,
      field: "Feb",
      headerName: "Feb",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      field: "Mar",
      headerName: "Mar",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      field: "Apr",
      headerName: "Apr",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      field: "May",
      headerName: "May",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      field: "Jun",
      headerName: "Jun",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      field: "Jul",
      headerName: "Jul",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      field: "Aug",
      headerName: "Aug",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      field: "Sep",
      headerName: "Sep",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      field: "Oct",
      headerName: "Oct",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      field: "Nov",
      headerName: "Nov",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      field: "Dec",
      headerName: "Dec",
      valueGetter: AgFormat.AgGridFormatMoney,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      comparator: AgFormat.AgNumberComparator,
      enableValue: true,
      field: "Ytd1",
      headerName: "YTD-1 (K€)",
      sort: "desc",
      valueGetter: AgFormat.AgGridFormatMoney,
      width: 300,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      comparator: AgFormat.AgNumberComparator,
      enableValue: true,
      field: "Ytd2",
      headerName: "YTD-2 (K€)",
      sort: "desc",
      valueGetter: AgFormat.AgGridFormatMoney,
      width: 300,
    },
    {
      aggFunc: AgFormat.columnTotal,
      cellClass: textRight,
      cellStyle: AgFormat.AgNumaricStyle,
      comparator: AgFormat.AgNumberComparator,
      enableValue: true,
      field: "Ytd3",
      headerName: "YTD-3 (K€)",
      sort: "desc",
      valueGetter: AgFormat.AgGridFormatMoney,
      width: 300,
    },
  ] as IHeader[];
  return header;
}
